import {
  Avatar,
  Box,
  Button,
  Container,
  CssBaseline,
  TextField,
  Typography,
  Alert,
} from '@mui/material';
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { login } from '../http/userAPI';
import { observer } from 'mobx-react-lite';
import { Context } from '..';
import { NEWS_ROUTE } from '../utils/consts';
import { getAccess } from '../http/accessAPI';

const formatPhoneNumber = (value) => {
  // Удаляем все нецифровые символы
  let cleaned = value.replace(/\D/g, '');

  // Заменяем начало 7 или +7 на 8
  if (cleaned.startsWith('7') && cleaned.length > 1) {
    cleaned = '8' + cleaned.slice(1);
  } else if (cleaned.startsWith('+7')) {
    cleaned = '8' + cleaned.slice(2);
  }

  // Ограничиваем длину до 11 цифр
  return cleaned.slice(0, 11);
};

const Login = observer(() => {
  const { user } = useContext(Context);
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);

    // Валидация номера телефона
    const formattedPhone = formatPhoneNumber(phone);
    if (formattedPhone.length !== 11 || !formattedPhone.startsWith('8')) {
      setError('Номер телефона должен быть в формате 80000000000');
      return;
    }

    // Валидация пароля
    if (!password.trim()) {
      setError('Введите пароль');
      return;
    }

    setLoading(true);

    try {
      const data = await login(formattedPhone, password);
      data.access = await getAccess(data.id);
      user.setUser(data);
      user.setIsAuth(true);
      await user.loadClinicData();
      navigate(NEWS_ROUTE);
    } catch (e) {
      setError(e.message || e.response?.data?.error || 'Ошибка при входе');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component='main' maxWidth='xs'>
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component='h1' variant='h5'>
          Вход
        </Typography>
        {error && (
          <Alert severity='error' sx={{ width: '100%', mt: 2 }}>
            {error}
          </Alert>
        )}
        <Box component='form' onSubmit={handleLogin} sx={{ mt: 1, width: '100%' }}>
          <TextField
            margin='normal'
            required
            fullWidth
            id='phone'
            label='Номер телефона'
            name='phone'
            autoFocus
            value={phone}
            onChange={(e) => setPhone(e.target.value)} // Убираем форматирование здесь
            placeholder='89991234567'
            inputProps={{
              maxLength: 12,
              inputMode: 'numeric',
            }}
          />
          <TextField
            margin='normal'
            required
            fullWidth
            name='password'
            label='Пароль'
            type='password'
            id='password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            type='submit'
            fullWidth
            variant='contained'
            sx={{ mt: 3, mb: 2 }}
            disabled={loading}
          >
            {loading ? 'Загрузка...' : 'Войти'}
          </Button>
        </Box>
      </Box>
    </Container>
  );
});

export default Login;
